import script from "./CurrentTillDateIncineratedChart.vue?vue&type=script&setup=true&lang=js"
export * from "./CurrentTillDateIncineratedChart.vue?vue&type=script&setup=true&lang=js"

import "./CurrentTillDateIncineratedChart.vue?vue&type=style&index=0&id=a3a71d02&lang=css"

const __exports__ = script;

export default __exports__